<div class="gb-auth-dialog-login">
  <div class="login-text">
    <mat-toolbar role="toolbar" class="gb-dialog-header">
      <h2 mat-dialog-title translate="AUTH.DIALOG.LOGIN.HEADER"></h2>
      <button mat-icon-button mat-dialog-close>
        <mat-icon mat-list-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <gb-social-login-register *ngIf="displaySocialLogin$ | async" [dialog]="true" [redirectHome]="false">
    </gb-social-login-register>
  </div>
  <gb-login-form [redirectHome]="false" [dialog]="true"> </gb-login-form>
  <div class="help-links">
    <p class="register-link">
      <span translate="AUTH.DIALOG.DONT_HAVE_AN_ACCOUNT"> </span>
      <a (click)="goToRegister()" translate="AUTH.DIALOG.GO_TO_REGISTER"> </a>
    </p>
    <div class="flex-row flex-justify-space-evenly flex-align-center px-gap-16">
      <p *ngIf="urlName$ | async as urlName">
        <a translate="AUTH.DIALOG.FORGOT_PASSWORD" (click)="goToForgotPassword(urlName)" mat-dialog-close> </a>
      </p>
      <p>
        <a translate="GO_TO_PRIVACY_POLICY" (click)="openPrivacyPolicy()"> </a>
      </p>
    </div>
  </div>
</div>
